import { useState, useEffect } from "react";
import UpdatePasswordForm from "./updatePasswordForm";
import { useToast } from "../../hooks/useToast";

const Settings = () => {
  const [active, setActive] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const { showToast, ToastContainer } = useToast();

  // Whenever toastMessage changes, show it
  useEffect(() => {
    if (toastMessage) {
      showToast(toastMessage, "success");
      setToastMessage(""); // reset after showing
    }
  }, [toastMessage]);

  return (
    <div className="max-w-2xl mx-auto p-6 relative">

      <ToastContainer />

      {!active && (
        <div className="space-y-4">
          <button
            onClick={() => setActive("password")}
            className="w-full px-4 py-3 rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            Change Password
          </button>
        </div>
      )}

      {active === "password" && (
        <UpdatePasswordForm
          onCancel={() => setActive(null)}
          onSuccess={(msg) => {
            setActive(null);      // go back immediately
            setToastMessage(msg); // trigger toast in Settings
          }}
        />
      )}
    </div>
  );
};

export default Settings;
